import { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import { EntregasRealizarContext } from 'contexts/EntregasRealizarContext';
import { toastWarning } from 'utils/toast';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import TipoModal from './Modals/TipoModal';
import columnOverrides from './columnOverrides';
import getEntregasRealizarFilterFields from './filterFields';

const Realizar = () => {
  const rotina = 'EntregasRealizar';
  const titulo = 'Entregas de Vendas a Realizar';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const {
    postNota,
    getLoading,
    postLoading,
    entregasRealizar,
    getEntregasRealizar,
  } = useContext(EntregasRealizarContext);

  const filterFields = useMemo(
    () => getEntregasRealizarFilterFields(drops),
    [drops]
  );

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();

    getEntregasRealizar({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: entregasRealizar?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: entregasRealizar?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={entregasRealizar?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Gerar Nota Fiscal',
      icon: 'post_add',
      action: (selected) => {
        const notas = selected?.filter((f) =>
          Boolean(f?.situacao !== 'ENCERRADO')
        );
        if (!Boolean(notas?.length)) {
          return toastWarning('Selecione apenas documentos não encerrados');
        } else {
          const onSubmit = (values) => {
            const data = { ...values, documentos: selected?.map((m) => m?.id) };

            postNota({ data, cb: loadGrid });
          };

          openModal(<TipoModal onSubmit={onSubmit} />);
        }
      },
    },
  ];

  const rowActions = [
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Documento/${row?.id}`),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={entregasRealizar?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={entregasRealizar}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          columnOverrides={columnOverrides}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading || postLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Realizar;
